<template>
  <nav class="nav">
    <div class="container">
      <router-link to="/" class="nav__logo">
        <img src="@/assets/images/logoDark.svg" alt="" class="nav__logo-img" />
      </router-link>

      <ul class="nav__list">
        <li class="nav__item">
          <router-link to="/" class="nav__rout">Home</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/products" class="nav__rout">Products</router-link>
        </li>
        <li class="nav__item">
          <router-link to="/about" class="nav__rout">Our Story</router-link>
        </li>
      </ul>

      <button class="nav__cart" @click="openAndClose">
        <cart-icon />
        <span class="nav__cart-quantity">{{ cart.length }}</span>
      </button>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import CartIcon from "@/assets/images/icons/CartIcon.vue";

export default {
  name: "Nav",
  components: { CartIcon },
  data() {
  },
  methods: {
    openAndClose() {
      this.$emit('openAndClose')
    }
  },
  computed: {
    ...mapState(["cart"]),
  },
};
</script>
